import { useTranslation } from 'react-i18next';

import { OptimizedImage, ImageData } from 'shared/components/ui/optimized-image/optimized-image';

interface ICardsBlock {
  count: number;
  max: number;
  cardToMint: ImageData;
  dec: () => void;
  inc: () => void;
  disabled: boolean;
  multiplyTo100?: boolean;
}

export const CardsBlock = ({
  count,
  max,
  cardToMint,
  dec,
  inc,
  disabled,
  multiplyTo100 = false,
}: ICardsBlock) => {
  const { t } = useTranslation();
  return (
    <div className="flex max-h-[10rem] flex-col gap-1">
      <div className="flex flex-col gap-1 rounded-xl border border-indigo bg-[#05055B] p-1">
        <div className="relative h-[4.125rem] w-full">
          {Array.from({ length: 9 }).map((_, i) => {
            const totalCards = Math.ceil(count);

            const isFirstOverflow = i === 0 && totalCards > 9;
            const isPlaceholder = totalCards <= 9 && i >= totalCards;

            return (
              <div
                key={i}
                className={`absolute top-0 flex aspect-[7/10] h-[4.125rem] w-[2.75rem] items-center justify-center overflow-hidden rounded-[0.25rem] ${
                  isFirstOverflow || isPlaceholder
                    ? 'flex items-center justify-center border border-indigo bg-[#07043A] text-xs font-bold text-white'
                    : 'bg-white/5'
                }`}
                style={{
                  left: `calc(${i} * (100% - 2.75rem) / 8)`,
                  zIndex: 9 - i,
                }}
              >
                {isFirstOverflow ? (
                  <div className="flex h-full w-full items-center justify-center rounded-lg">
                    +{totalCards}
                  </div>
                ) : !isPlaceholder ? (
                  <OptimizedImage
                    imageData={cardToMint}
                    alt="Material"
                    className="h-full w-full object-cover"
                  />
                ) : null}
              </div>
            );
          })}
        </div>

        <div className="relative overflow-hidden rounded-lg border border-indigo bg-[linear-gradient(180deg,_#B88041_0%,_#5A4458_100%)] p-[0.25rem]">
          <div className="relative z-10 flex h-full w-full items-center justify-center font-semibold text-white">
            {multiplyTo100 ? count * 100 : count}/{max}
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between rounded-xl border border-indigo bg-[#05055B] p-1">
        <div className="flex w-full items-center gap-3">
          <button
            onClick={dec}
            disabled={count === 0 || disabled}
            className="h-9 w-9 rounded-[0.5rem] bg-[linear-gradient(180deg,_#2D054D_0%,_#80032F_100%)] text-lg text-white disabled:opacity-40"
          >
            -
          </button>
          <button
            onClick={inc}
            disabled={count === max || disabled}
            className="flex-1 rounded-[0.5rem] border border-white/10 bg-[linear-gradient(180deg,_#0C0C60_0%,_#181868_100%)] px-3 py-1 text-base text-white disabled:opacity-40"
          >
            {t('nft.addMore')}
          </button>
        </div>
      </div>
    </div>
  );
};
